import { Cormorant_Garamond, Manrope } from "next/font/google";

const display = Cormorant_Garamond({
  subsets: ["latin"],
  weight: ["500", "600"],
  style: ["normal", "italic"],
  variable: "--font-display",
});

const sans = Manrope({
  subsets: ["latin"],
  weight: ["400", "500", "600"],
  variable: "--font-public-sans",
});

export const publicType = `${display.variable} ${sans.variable} [font-family:var(--font-public-sans)]`;
export const publicShell = `${publicType} min-h-screen bg-[#f8f2f4] text-[#25122a]`;
export const serif = "[font-family:var(--font-display)]";
